import React, { memo, useEffect, useRef, } from 'react';
import classNames from 'classnames/bind';
import { CSSTransition } from 'react-transition-group';
import { noop } from '../utils/noop';
import { getBackgroundColor } from './_utils/get-background-color';
import { disableScroll, enableScroll } from './_utils/scroll-controlls';
import styles from './overlay.module.scss';
var cn = classNames.bind(styles);
var DEFAULT_TIME_TO_SHOW_OVERLAY = 500;
var DEFAULT_OPACITY_VALUE = '0.7';
var BLOCK_NAME = 'Overlay';
export var Overlay = memo(function (_a) {
    var _b;
    var absolute = _a.absolute, children = _a.children, inherit = _a.inherit, _c = _a.onClick, onClick = _c === void 0 ? noop : _c, _d = _a.opacity, opacity = _d === void 0 ? DEFAULT_OPACITY_VALUE : _d, opened = _a.opened, _e = _a.timeout, timeout = _e === void 0 ? DEFAULT_TIME_TO_SHOW_OVERLAY : _e, transparent = _a.transparent, whiteBackground = _a.whiteBackground, withBorderRadius = _a.withBorderRadius, isExitAnimationDisabled = _a.isExitAnimationDisabled;
    var element = useRef(null);
    useEffect(function () {
        if (element.current) {
            var backgroundColor = getBackgroundColor({
                opacity: opacity,
                whiteBackground: whiteBackground,
                inherit: inherit,
                transparent: transparent,
            });
            // set dynamic styles
            element.current.style.setProperty('background-color', backgroundColor);
            element.current.style.setProperty('transition-duration', "".concat(timeout, "ms"));
            element.current.style.setProperty('animation-duration', "".concat(timeout, "ms"));
        }
    }, [opacity, timeout, opened, whiteBackground, inherit, transparent]);
    useEffect(function () {
        if (!absolute && opened) {
            disableScroll();
        }
        return function () {
            if (!absolute && opened) {
                enableScroll();
            }
        };
    }, [absolute, opened]);
    return (React.createElement(CSSTransition, { classNames: {
            enter: cn("".concat(BLOCK_NAME, "--enter")),
            exit: cn(isExitAnimationDisabled ? '' : "".concat(BLOCK_NAME, "--exit")),
        }, "data-name": "Overlay", in: opened, timeout: {
            enter: timeout,
            exit: isExitAnimationDisabled ? 0 : timeout,
        }, unmountOnExit: true },
        React.createElement("div", { ref: element, className: cn(BLOCK_NAME, (_b = {},
                _b["".concat(BLOCK_NAME, "--absolute")] = absolute,
                _b["".concat(BLOCK_NAME, "--curved")] = withBorderRadius,
                _b)), onClick: onClick, role: "presentation" }, children)));
});
